
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M13.81 2.86C13.98 2.56 13.81 2.16 13.46 2.12C10.84 1.75 8.15999 2.4 6.01999 3.98C5.82999 4.13 5.76999 4.41 5.89999 4.63L8.90999 9.85C9.09999 10.18 9.57999 10.18 9.77999 9.85L13.81 2.86ZM21.3 8.33C20.32 5.86 18.38 3.87 15.95 2.83C15.72 2.73 15.45 2.83 15.32 3.05L12.31 8.26C12.12 8.58 12.36 9 12.75 9H20.83C21.18 9 21.43 8.65 21.3 8.33ZM21.37 10H15.17C14.79 10 14.54 10.42 14.74 10.75L19 18.14C19.17 18.44 19.6 18.49 19.82 18.22C21.56 16.04 22.3 13.19 21.87 10.43C21.84 10.18 21.62 10 21.37 10ZM4.17999 5.79C2.44999 7.98 1.69999 10.81 2.12999 13.58C2.15999 13.82 2.37999 14 2.62999 14H8.82999C9.20999 14 9.45999 13.58 9.25999 13.25L4.99999 5.87C4.81999 5.57 4.38999 5.52 4.17999 5.79ZM2.69999 15.67C3.67999 18.14 5.61999 20.13 8.04999 21.17C8.27999 21.27 8.54999 21.17 8.67999 20.95L11.69 15.74C11.88 15.41 11.64 14.99 11.26 14.99H3.16999C2.81999 15 2.56999 15.35 2.69999 15.67ZM10.53 21.89C13.15 22.26 15.83 21.61 17.97 20.03C18.17 19.88 18.23 19.59 18.1 19.37L15.09 14.15C14.9 13.82 14.42 13.82 14.22 14.15L10.18 21.14C10.01 21.44 10.19 21.84 10.53 21.89Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-camera`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconCamera

    ```js
    <b-new-b-icon-camera />
    ```
</docs>


